// extracted by mini-css-extract-plugin
export default {"pageWrap":"ra-z","fullWidth":"sa-z","heading":"ta-z","fullBleed":"ua-z","hidden":"va-z"};